// ChangePasswordModal.js

import React, { useState } from "react";
import logger from "../../utils/logger";
import {
  Button,
  Col,
  Form,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";

// Redux Toolkit
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { changePassword } from "../../slices/apps/userSlice";

// Formik ve Yup
import * as Yup from "yup";
import { useFormik } from "formik";

const ChangePasswordModal = ({ isOpen, toggle }) => {
  const dispatch = useDispatch();

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);

  const { currentUser, updateUserLoading } = useSelector(
    (state) => ({
      currentUser: state.auth.isUserData,
      updateUserLoading: state.user.updateUserLoading,
    }),
    shallowEqual
  );

  // Formik validation
  const validation = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string().required("Lütfen mevcut şifrenizi giriniz."),
      newPassword: Yup.string()
        .min(6, "Yeni şifre en az 6 karakter olmalıdır.")
        .required("Lütfen yeni bir şifre belirleyiniz."),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        await dispatch(
          changePassword({ ...values, phoneNumber: currentUser.phoneNumber })
        ).unwrap();

        toggle();
        resetForm();
      } catch (error) {
        logger.error("Şifre değiştirme başarısız:", error);
      }
    },
  });

  return (
    <Modal size="md" isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader
        className="modal-title"
        id="myLargeModalLabel"
        toggle={toggle}
      >
        Şifre Değiştir
      </ModalHeader>

      <ModalBody className="p-4">
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
          autoComplete="off"
        >
          <Row className="gy-3">
            <Col lg={12}>
              <Label htmlFor="oldpassword-input">Mevcut Şifre</Label>
              <InputGroup>
                <span
                  className="input-group-text"
                  style={{ width: "44px" }}
                  id="inputGroupPrepend1"
                >
                  <i
                    onClick={() => setShowOldPassword(!showOldPassword)}
                    style={{ cursor: "pointer", color: "gray" }}
                    className={
                      showOldPassword
                        ? "ri-eye-off-fill align-middle"
                        : "ri-eye-fill align-middle"
                    }
                  ></i>
                </span>
                <Input
                  id="oldpassword-input"
                  type={showOldPassword ? "text" : "password"}
                  name="oldPassword"
                  className="form-control"
                  placeholder="Mevcut şifreniz"
                  value={validation.values.oldPassword}
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={
                    !!(
                      validation.touched.oldPassword &&
                      validation.errors.oldPassword
                    )
                  }
                />
              </InputGroup>
              {validation.touched.oldPassword &&
                validation.errors.oldPassword && (
                  <div className="invalid-feedback d-block">
                    {validation.errors.oldPassword}
                  </div>
                )}
            </Col>

            <Col lg={12}>
              <Label htmlFor="newpassword-input">Yeni Şifre</Label>
              <InputGroup>
                <span
                  className="input-group-text"
                  style={{ width: "44px" }}
                  id="inputGroupPrepend2"
                >
                  <i
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    style={{ cursor: "pointer", color: "gray" }}
                    className={
                      showNewPassword
                        ? "ri-eye-off-fill align-middle"
                        : "ri-eye-fill align-middle"
                    }
                  ></i>
                </span>
                <Input
                  id="newpassword-input"
                  type={showNewPassword ? "text" : "password"}
                  name="newPassword"
                  className="form-control"
                  placeholder="Yeni şifreniz"
                  value={validation.values.newPassword}
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={
                    !!(
                      validation.touched.newPassword &&
                      validation.errors.newPassword
                    )
                  }
                />
              </InputGroup>
              {validation.touched.newPassword &&
                validation.errors.newPassword && (
                  <div className="invalid-feedback d-block">
                    {validation.errors.newPassword}
                  </div>
                )}
            </Col>
          </Row>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button
              type="submit"
              color="primary"
              className="btn btn-label"
              disabled={updateUserLoading}
            >
              <i className="ri-check-line label-icon align-middle me-2"></i>{" "}
              Kaydet
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default ChangePasswordModal;
